/* cjl-highlight-statement — una palabra rota UNA vez y se queda en la última (sections/cjl-highlight-statement.liquid).
   Caja de ancho fijo (palabra más larga + coma) centrada en su línea: la palabra, la coma y el marcador
   se mueven solo por transform → la línea no cambia de ancho y CLS = 0.
   Arranque: sección ≥50% en pantalla (IO, una vez). Cada `data-hold` ms sale la palabra actual hacia arriba
   y entra la siguiente desde abajo (250 ms); marcador y coma se ajustan al nuevo ancho (200 ms).
   reduced-motion o animación off: no se arma nada (queda la frase final del HTML).
   Editor: limpia en section:unload, re-arma en section:load. */
(function () {
  'use strict';
  var instances = {};
  var PAD = 0.14; /* el marcador sobresale 0.14em por cada lado de la palabra */

  function init(root) {
    var id = root.dataset.sectionId;
    if (!id || instances[id]) return;
    if (root.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var slot = root.querySelector('[data-slot]');
    var words = [].slice.call(root.querySelectorAll('[data-w]'));
    var mk = root.querySelector('[data-mk]');
    var comma = root.querySelector('[data-comma]');
    if (!slot || words.length < 2) return;

    var widths = [], commaW = 0, boxW = 0, cur = 0, timer = 0, io = null;

    function em() { return parseFloat(getComputedStyle(slot).fontSize) || 16; }

    function measure() {
      root.classList.add('no-tr');
      widths = words.map(function (w) { return w.getBoundingClientRect().width; });
      commaW = comma ? comma.getBoundingClientRect().width : 0;
      boxW = Math.ceil(Math.max.apply(null, widths) + commaW);
      slot.style.setProperty('--box-w', boxW + 'px');
    }

    function place(i) {
      var x = (boxW - widths[i] - commaW) / 2;
      var pad = PAD * em();
      words[i].style.setProperty('--x', x + 'px');
      if (mk) {
        slot.style.setProperty('--mx', (x - pad) + 'px');
        slot.style.setProperty('--ms', ((widths[i] + 2 * pad) / 100).toFixed(4));
      }
      if (comma) slot.style.setProperty('--cx', (x + widths[i]) + 'px');
    }

    function show(i, instant) {
      if (instant) root.classList.add('no-tr');
      words.forEach(function (w, k) {
        w.classList.toggle('is-on', k === i);
        w.classList.remove('is-below', 'is-above');
      });
      place(i);
      if (instant) { void root.offsetWidth; root.classList.remove('no-tr'); }
      cur = i;
    }

    function step() {
      var next = cur + 1;
      if (next >= words.length) { clearInterval(timer); timer = 0; return; }
      var out = words[cur], inn = words[next];
      /* la entrante se coloca abajo sin transición y luego sube */
      inn.style.transition = 'none';
      inn.classList.add('is-below');
      place(next);
      void inn.offsetWidth;
      inn.style.transition = '';
      inn.classList.remove('is-below');
      inn.classList.add('is-on');
      out.classList.remove('is-on');
      out.classList.add('is-above');
      cur = next;
      if (next === words.length - 1) { clearInterval(timer); timer = 0; }
    }

    function start() {
      if (root.classList.contains('is-played')) return;
      root.classList.add('is-played'); /* dispara también el trazo del subrayado, si está activo */
      var hold = parseInt(root.dataset.hold, 10) || 800;
      timer = setInterval(step, hold);
    }

    var onResize = function () {
      measure();
      show(cur, true);
    };

    var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(function () {
      if (!instances[id]) return; /* descargada mientras cargaban las fuentes */
      root.classList.add('is-js', 'is-armed');
      measure();
      show(0, true);
      window.addEventListener('resize', onResize);
      io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect(); io = null;
        start();
      }, { threshold: 0.5 });
      io.observe(root);
    });

    instances[id] = {
      destroy: function () {
        if (io) io.disconnect();
        clearInterval(timer);
        window.removeEventListener('resize', onResize);
        delete instances[id];
      }
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-cjl-statement]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-cjl-statement]');
    if (root && instances[root.dataset.sectionId]) instances[root.dataset.sectionId].destroy();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
